export class TimeZone {

  private _zone: string; // in minutes
  private _label: string;
  private _abbreviation: string;

  constructor(offset: string, label: string, abbreviation: string) {
    this._zone = offset;
    this._label = label;
    this._abbreviation = abbreviation;
  }

  get zone(): string {
    return this._zone;
  }

  set zone(value: string) {
    this._zone = value;
  }

  get label(): string {
    return this._label;
  }

  set label(value: string) {
    this._label = value;
  }

  get abbreviation(): string {
    return this._abbreviation;
  }

  set abbreviation(value: string) {
    this._abbreviation = value;
  }

}
